import listViewStore from 'owa-mail-list-store/lib/store/Store';
import {
    lazyGetLastestNonDraftItemId,
    lazyLoadConversationReadingPane,
} from 'owa-mail-reading-pane-store';
import { ClientItemId } from 'owa-client-ids';

async function getLatestNonDraftItemIdFromConversation(
    conversationId: ClientItemId
): Promise<ClientItemId> {
    const getLatestNonDraftItemId = await lazyGetLastestNonDraftItemId.import();

    // If we can't getLatestNonDraftItemId at first, try loadConversationReadingPane then getLatestNonDraftItemId
    if (!getLatestNonDraftItemId(conversationId)) {
        const conversation = listViewStore.conversationItems.get(conversationId.Id);
        if (conversation) {
            const loadConversationReadingPane = await lazyLoadConversationReadingPane.import();
            await loadConversationReadingPane(
                conversationId,
                null /* instrumentationContext */,
                conversation.subject
            );
        }
    }

    return getLatestNonDraftItemId(conversationId);
}

export default getLatestNonDraftItemIdFromConversation;
